// import { BaseQueryArg } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import ILogin from "../../model/ILogin";
import { IUser } from "../../model/IUser";
import { IOauthState } from "../pages/Oauth.page";
import api, { transformResponse } from './api';

type TWithRecaptchaToken<T> = T & { tokenRecaptcha: string };

export const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    signIn: build.mutation<ILogin, TWithRecaptchaToken<IOauthState['signIn']>>({
      query: (body) => ({
        url: 'oauth/signin',
        method: 'POST',
        body,
      }),
    }),

    signUp: build.mutation<IUser, TWithRecaptchaToken<IOauthState['signUp']>>({
      query: (body) => ({
        url: 'oauth/signup',
        method: 'POST',
        body,
      }),
    }),

    activate: build.mutation<IUser, TWithRecaptchaToken<IOauthState['activate']>>({
      query: (body) => ({
        url: 'oauth/activate',
        method: 'POST',
        body,
      }),
    }),

    // logout: build.mutation<string, unknown>({
    //   query: () => ({
    //     method: 'POST',
    //     url: '/oauth/logout',
    //   }),
    //   // invalidatesTags: ['Rules'],
    // }),

    me: build.query<IUser, unknown>({
      query: () => ({
        url: '/users/me',
      }),
    }),
  }),
});
